import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {
  IconSizes,
  IconUsageTypes,
  IrisIconModule,
} from '@sondermind/iris/icon';

@Component({
  standalone: true,
  selector: 'expandable-panel',
  templateUrl: './expandable-panel.component.html',
  styleUrls: ['./expandable-panel.component.scss'],
  imports: [CommonModule, IrisIconModule],
  encapsulation: ViewEncapsulation.None
})

// TODO: would be nice to have this component have an animated dropdown effect
// just like the mat expansion panel, but not required
export class ExpandablePanelComponent implements OnInit {
  @Input() panelHeaderText: string = '';
  @Input() expandableBodyText: string = '';

  iconSize = IconSizes.MD;
  iconType = IconUsageTypes.DECORATIVE;

  isPanelOpen: boolean = false;

  ngOnInit(): void {
    this.isPanelOpen = false;
  }

  togglePanel(): void {
    this.isPanelOpen = !this.isPanelOpen;
  }
}
